<template>
    <div>
        <b-modal
            :id="modalId"
            modal-class="modal-serial"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div
                    @click="close()"
                    class="text-right"
                    style="
                        margin-top: 0px;
                        margin-right: 0px;
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                    >
                        <path
                            d="m11.442 10.275 8.577-8.577A.833.833 0 0 0 18.841.519l-8.578 8.578L1.686.519A.833.833 0 0 0 .507 1.698l8.578 8.577-8.578 8.578a.833.833 0 0 0 1.179 1.178l8.577-8.577 8.578 8.577a.833.833 0 0 0 1.178-1.178l-8.577-8.578z"
                            fill="#000"
                        />
                    </svg>
                </div>
                <div class="modal-base-head">
                    <SerialHeader :serialModel="serialModel" />
                </div>
                <div class="modal-base-body">
                    <Serial
                        :lbl="lbl"
                        :serialModel="serialModel"
                        :controller="controller"
                    />
                    <SerialTopHeader :serialModel="serialModel" />
                    <SerialTimer
                        :lbl="lbl"
                        :serialModel="serialModel"
                        :controller="controller"
                    />
                </div>
                <div class="modal-base-footer">
                    <SerialFooter />
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Moment from "moment";
//helper
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
//component
import Serial from "./Component/Serial.vue";
import SerialFooter from "./Component/SerialFooter.vue";
import SerialHeader from "./Component/SerialHeader.vue";
import SerialTopHeader from "./Component/SerialTopHeader.vue";
import SerialTimer from "./Component/SerialTimer.vue";

export default {
    name: "SerialModal",
    components: {
        Serial,
        SerialFooter,
        SerialHeader,
        SerialTimer,
        SerialTopHeader
    },
    props: {
        controller: Object,
        modalId: String
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),

            serialModel: {},
            tag: null,

            busModal: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        //event
        close: function() {
            this.hide();
            this.$router.go();
        },
        getRedeemMessage: function() {
            var expireDate = this.serialModel.redeemTimestamp;
            var result = Moment.unix(expireDate).utc();
            var year = result.format("YYYY");
            if (Locale.getLocaleCode() === 1033) {
                year = result.get("year") + 543;
            }

            var day = result.format("DD");
            var month = result.format("MM");
            var date = `${day}/${month}/${year} - ${result.format("HH:mm")}`;

            return Util.stringFormat(this.lbl.serial.redeem_on, date);
        },
        //modal
        show: function(config) {
            this.serialModel = config.serialModel;
            console.log(this.serialModel)
            this.tag = config.tag;

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#redeem_on_date {
    font-size: 16px;
    color: #333333;
    text-align: center;
    font-family: "KanitRegular";
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-serial {
    @extend %modal-base;
    .modal-dialog{
        padding: calc(30% + 20px) 15px 20px;
        .modal-content{
            overflow: visible;
            .modal-body .modal-base .modal-base-head{
                width: 100%;
                float: left;
            }
        }
    }
}
.icon-back-modal {
    position: absolute;
    top: 12px;
    right: 13px;
}
.btn-close {
    font-size: 16px;
    background: #6ba73c;
    border-radius: 25px;
    color: #fff;
    height: 45px;
    line-height: 45px;
    width: 150px;
    margin: auto;
}
</style>
